export default {
    ABSTRACT: 'Abstract',
    ACCESS: 'Access',
    ACCESS_TO_DOCUMENT_IS_AVAILABLE_ONLY_FROM_RSL: 'Access to document is available only from RSL.',
    ADD: 'Add',
    ADVANCED_SEARCH: 'Advanced search',
    ADVANCED_SEARCH_HELP: 'Advanced search help',
    ALL_FIELDS: 'All fields',
    ALPHABETICAL_INDEX: 'Alphabetical index',
    AND: 'and',
    AND_NOT: 'and not',
    AN_ERROR_OCCURRED_WHILE_ADDING_DOCUMENT_TO_FAVORITES: 'An error occurred while adding document to favorites.',
    AN_ERROR_OCCURRED_WHILE_LOADING_THE_DATA: 'An error occurred while loading the data.',
    AN_ERROR_OCCURRED_WHILE_PROCESSING_YOUR_REQUEST_BY_THE_SERVER: 'An error occurred while processing your request by the server.',
    AN_ERROR_OCCURRED_WHILE_REMOVING_THE_DOCUMENT_FROM_FAVORITES: 'An error occurred while removing the document from favorites.',
    AN_ERROR_OCCURRED_WHILE_TRYING_TO_LOG_IN_PLEASE_CONTACT_ADMINISTRATOR: 'An error occurred while trying to log in. Please contact administrator.',
    AN_ERROR_OCCURRED_WHILE_TRYING_TO_LOG_IN_THROUGH_UNIFIED_AUTHORIZATION_SYSTEM_PLEASE_CONTACT_ADMINISTRATOR: 'An error occurred while trying to log in through unified authorization system. Please contact administrator.',
    ARRIVALS: 'Arrivals',
    ART_EDITIONS: 'art editions',
    AUTHOR: 'Author',
    AUTHOR_DOCUMENT_TITLE_OR_KEY_WORDS: 'Author, document title or key words',
    BBK_INDEX: 'BBK index',
    BIBLIOMETRIC: 'Bibliometric',
    BY_AUTHORS: 'By authors',
    BY_AUTHOR_IN_ASCENDING_ORDER: 'By author (in ascending order)',
    BY_AUTHOR_IN_DESCENDING_ORDER: 'By author (in descending order)',
    BY_DATE_OF_RECEIPT_IN_ELECTRONIC_CATALOGUE_IN_ASCENDING_ORDER: 'By date of receipt in electronic catalogue (in ascending order)',
    BY_DATE_OF_RECEIPT_IN_ELECTRONIC_CATALOGUE_IN_DESCENDING_ORDER: 'By date of receipt in electronic catalogue (in descending order)',
    BY_DATE_OF_RECEIPT_IN_ELECTRONIC_LIBRARY_IN_ASCENDING_ORDER: 'By date of receipt in electronic library (in ascending order)',
    BY_DATE_OF_RECEIPT_IN_ELECTRONIC_LIBRARY_IN_DESCENDING_ORDER: 'By date of receipt in electronic library (in descending order)',
    BY_PUBLICATION_DATE_IN_ASCENDING_ORDER: 'By publication date (in ascending order)',
    BY_PUBLICATION_DATE_IN_DESCENDING_ORDER: 'By publication date (in descending order)',
    BY_RELEVANCE: 'By relevance',
    BY_TITLE: 'By title',
    BY_TITLE_ASC: 'By title (ASC)',
    BY_TITLE_DESC: 'By title (DESC)',
    CANCEL_REQUEST_FOR_DIGITIZING: 'Cancel request for digitizing',
    CATALOGUE: 'Catalogue',
    CATALOGUES: 'Catalogues',
    CATALOGUE_CARD: 'Catalogue card',
    CATALOGUE_OF_RECORDS: 'Catalogue of records',
    CHOOSE: 'choose',
    CHOOSE_DISCIPLINE: 'Choose discipline',
    CHOOSE_LANGUAGE: 'Choose language',
    CHOOSE_LANGUAGES: 'Choose languages',
    CLEAR: 'Clear',
    CLEAR_ALL_FILTERS: 'clear all filters',
    CLOSE: 'Close',
    COLLECTION: 'Collection',
    COMMENTS: 'Comments',
    CONFIRM: 'Confirm',
    CONSISTS_OF: 'Consists of',
    CONTENT: 'Content',
    CONTENTS: 'Contents',
    CONTINUE: 'Continue',
    COPIES_OF_THE_DOCUMENT_AVAILABLE_FOR_THE_ELECTRONIC_ORDER_WERE_NOT_FOUND: 'Copies of the document available for the electronic order were not found.',
    DATABASE_ACCESS: 'Database access',
    DATABASE_ACCESS_ON_THE_PLATFROM_OF_RUSSIAN_ARCHIVE_OF_ACADEMIC_JOURNALS: 'Database access on the platfrom of Russian Archive of Academic Journals',
    DATABASE_ACCESS_ON_THE_PUBLISHER_PLATFORM: 'Database access on the publisher platform',
    DATE_OF_RECEIPT_IN_ELECTRONIC_CATALOGUE: 'Date of receipt in electronic catalogue',
    DATE_OF_RECEIPT_IN_THE_ELECTRONIC_LIBRARY: 'Date of receipt in the electronic library',
    DATE_OF_RECEIPT_IN_THE_FUND: 'Date of receipt in the fund',
    DECLINE: 'Decline',
    DEPOSITED_DOCUMENTS: 'Deposited documents',
    DESCRIPTION: 'Description',
    DEVELOPED_IN: 'developed in',
    DID_YOU_MEAN_SEARCH_FOR_WORD: 'Did you mean search for {word}?',
    DIGITAL: 'Digital',
    DIGITAL_COPY: 'Digital copy',
    DIGITAL_DOCUMENTS_FUND: 'Digital documents fund',
    DIGITAL_LIBRARY_COLLECTIONS: 'Digital library collections',
    DISCIPLINE: 'Discipline',
    DISSERTATION: 'dissertation',
    DISSERTATION_ABSTRACT: 'dissertation abstract',
    DOCUMENT: 'document',
    DOCUMENT_IN_THE_BRANCH: 'document in the branch',
    DOCUMENT_IS_IN_LIMITED_ACCESS: 'Document is in limited access.',
    DOCUMENT_IS_FREELY_AVAILABLE: 'Document is freely available.',
    DOCUMENT_IS_TEMPORARILY_UNAVAILABLE: 'Document is temporarily unavailable.',
    DOCUMENT_WAS_ADDED_TO_FAVORITES: 'Document was added to favorites.',
    DOCUMENT_WAS_REMOVED_FROM_FAVORITES: 'Document was removed from favorites.',
    DOCUMENT_WITH_THIS_IDENTIFIER_WAS_NOT_FOUND: 'Document with this identifier was not found.',
    DOWNLOAD_MARC21_RECORD: 'Download marc21 record',
    DOWNLOAD_RUSMARC_RECORD: 'Download rusmarc record',
    DOWNLOAD_DOCUMENT: 'Download document',
    EDITION: 'Edition',
    ELECTRONIC_ORDER: 'Electronic order',
    ELECTRONIC_ORDER_FOR_THE_DOCUMENT_WAS_SUCCESSFULLY_CONFIRMED: 'Electronic order for the document was successfully confirmed.',
    ELECTRONIC_RESOUCE: 'Electronic resouce',
    ELEVATE: 'Elevate',
    ENTER_DISCIPLINE: 'Enter discipline',
    ENTER_IDENTIFIER: 'Enter identifier',
    ENTER_LANGUAGE: 'Enter language',
    ENTER_PUBLISHER: 'Enter publisher',
    ENTER_SEARCH_PHRASE: 'Enter search phrase',
    ENTER_VALUE: 'Enter value',
    EXTERNAL_RESOURCES: 'External resources',
    FAVORITES: 'Favorites',
    FILE_NOT_FOUND: 'File not found',
    FILL_IN_ALL_THE_REQUIRED_FIELDS: 'Fill in all the required fields:',
    FREE: 'Free',
    FREE_ACCESS: 'free access',
    FULL_TEXT: 'Full-text',
    GENERAL_ELECTRONIC_CATALOGUE: 'General electronic catalogue',
    GO_TO_AUTOABSTRACT: 'Go to autoabstract',
    GO_TO_DISSERTATION: 'Go to dissertation',
    GO_TO_HOMEPAGE: 'Go to homepage',
    HELP: 'Help',
    HIDE: 'hide',
    HIGHER_ATTESTATION_COMMISION_DISCIPLINES: 'Higher Attestation Commision disciplines',
    IDENTIFIER_OF_THE_DOCUMENT: 'Identifier of the document',
    IMPRINT: 'Imprint',
    INCORRECT_FILTER_DATA: 'Incorrect filter data',
    INCORRECT_QUERY: 'Incorrect query.',
    INCORRECT_QUERY_PARAMETERS: 'Incorrect query parameters',
    INTERNAL_ERROR: 'Internal error.',
    INVALID_ID_FORMAT: 'Invalid ID format.',
    INVALID_RECORD_IDENTIFIER: 'Invalid record identifier.',
    INVALID_REQUEST_TYPE: 'Invalid request type.',
    KEY_WORDS: 'Key words',
    LANGUAGE: 'Language',
    LANGUAGES: 'Languages',
    LICENSE: 'License',
    LIMITED_ACCESS: 'limited access',
    LIMIT_OF_QUERIES_FOR_DOWNLOAD_WAS_EXCEEDED_PLEASE_TRY_LATER: 'Limit of queries for download was exceeded. Please try later.',
    LITRES: 'Litres',
    LOADING: 'loading...',
    LOGIN: 'Login',
    LOGOUT: 'Logout',
    MARK_AS_DIGITIZED: 'Mark as digitized',
    MATCHES_FOUND: 'Matches found',
    MORE: 'more',
    NAME_OF_A_PERSON: 'Name of a person',
    NOTES: 'notes',
    NO_DATA_AVAILABLE: 'No data available.',
    NO_DATA_IS_AVAILABLE: 'No data is available.',
    NO_MATCHES_WERE_FOUND_FOR_YOUR_QUERY_TRY_TO_CHANGE_THE_QUERY: 'No matches were found for your query. Try to change the query.',
    NO_SELECTED_ITEMS: 'No selected items',
    N_SEC: '{n} sec.',
    OR: 'or',
    ORDER: 'Order',
    ORDER_FROM_AFFILIATED_BRANCH: 'order from affiliated branch',
    ORDER_FROM_STORAGE: 'order from storage',
    ORDER_IN_SPECIALIZED_DEPARTMENT: 'order in specialized department',
    ORDER_USING_ALEPH: 'order using Aleph',
    OR_ENTER_IDENTIFIER_OF_THE_DOCUMENT: 'Or enter identifier of the document:',
    PAGE: 'page',
    PAGE_N: 'page. {number}',
    PAGE_NOT_FOUND: 'Page not found',
    PASSWORD: 'Password',
    PERIODICAL: 'Periodical',
    PERSONALIA: 'Personalia',
    PHYSICAL_DESCRIPTION: 'Physical description',
    PLACE_OF_PUBLICATION: 'Place of publication',
    PLEASE_FILL_IN_THE_FOLLOWING_FIELDS_TO_LOGIN: 'Please fill in the following fields to login:',
    PREVIEW_UNAVAILABLE: 'Preview unavailable',
    PROFESSIONAL_SEARCH: 'Professional search',
    PROFILE: 'Profile',
    PUBLICATION_DATE: 'Publication date',
    PUBLISHED_BY: 'Published by',
    PUBLISHED_FROM: 'Published from',
    PUBLISHER: 'Publisher',
    PUBLISHING_HOUSE: 'Publishing house',
    PUT_DOWN: 'Put down',
    QUOTATIONS_FROM_THE_TEXT: 'Quotations from the text',
    READ: 'Read',
    REFERENCE_BIBLIOGRAPHIC: 'Reference-bibliographic',
    REGISTRATION_NUMBER: 'Registration number',
    REGULATIONS: 'regulations',
    REMEMBER: 'Remember',
    REQUEST_CANNOT_BE_SUBMITTED_USER_IS_UNDEFINED: 'Request cannot be submitted: user is undefined.',
    REQUEST_FOR_DIGITIZING_THIS_DOCUMENT_HAS_ALREADY_BEEN_REGISTERED_IN_THE_SYSTEM: 'Request for digitizing this document has already been registered in the system.',
    REQUEST_FOR_DIGITIZING_THIS_DOCUMENT_HAS_BEEN_ACCEPTED: 'Request for digitizing this document has been accepted.',
    REQUEST_FOR_DIGITIZING_THIS_DOCUMENT_HAS_BEEN_CANCELLED: 'Request for digitizing this document has been cancelled.',
    REQUEST_LIMIT_EXCEEDED_PLEASE_TRY_LATER: 'Request limit exceeded. Please try later.',
    REQUIRED_COPY_OF_THE_DOCUMENT_IS_NOT_FOUND_OR_IS_NOT_AVAILABLE_FOR_ORDER: 'Required copy of the document is not found or is not available for order.',
    RESOURCE_TYPE: 'Resource type',
    RESPONSIBILITY: 'Responsibility',
    RESTRICTED: 'Restricted',
    RESULTS: 'results',
    RESULTS_INCLUDE_THE_FOLLOWING_SYNONYMS: 'Results include the following synonyms:',
    RETRIEVED_IN_ELECTRONIC_CATALOGUE: 'Retrieved in electronic catalogue',
    RETRIEVED_IN_ELECTRONIC_CATALOGUE_BY: 'Retrieved in electronic catalogue by',
    RETRIEVED_IN_ELECTRONIC_CATALOGUE_FROM: 'Retrieved in electronic catalogue from',
    RETRIEVED_IN_ELECTRONIC_LIBRARY: 'retrieved in electronic library',
    RETRIEVED_IN_ELECTRONIC_LIBRARY_BY: 'Retrieved in electronic library by',
    RETRIEVED_IN_ELECTRONIC_LIBRARY_FROM: 'Retrieved in electronic library from',
    RSL: 'RSL',
    RUSSIAN_STATE_LIBRARY: 'Russian<br>State<br>Library',
    SEARCH: 'Search',
    SEARCH_FIELDS: 'Search fields',
    SEARCH_PHRASE: 'search phrase',
    SEARCH_PREFIX: 'search prefix',
    SEARCH_STEMMING: 'search stemming',
    SEARCH_WITHOUT_STEMMING: 'search without stemming',
    SERIES: 'Series',
    SERVICES: 'Services',
    SHOW: 'show',
    SOME_OF_IDENTIFIERS_HAVE_AN_INCORRECT_FORMAT: 'Some of identifiers have an incorrect format.',
    SORTING: 'Sorting',
    STATISTICAL_DATABASE: 'Statistical database',
    STORAGE_CODE: 'Storage code',
    STORAGE_LOCATION: 'Storage location',
    SUBJECT: 'Subject',
    THEME: 'Theme',
    THE_DOCUMENT_IS_ACCESSIBLE_FROM_ANYWHERE_THROUGH_THE_SECURE_VIEWER: 'The document is accessible from anywhere through the secure viewer.',
    THE_DOCUMENT_IS_PROTECTED_BY_COPYRIGHT_FULL_TEXT_IS_AVAILABLE_IN_RSL_AND_VIRTUAL_READING_ROOMS: 'The document is protected by copyright. Full text is available in RSL and virtual reading rooms.',
    THE_ENTRY_IS_NOT_FOUND: 'The entry is not found.',
    THE_OPTION_TO_SUBMIT_A_REQUEST_IS_OFF: 'The option to submit a request is off.',
    THE_QUERY_REPLACED_FAILED_A_SEARCH_WAS_CONDUCTED_FOR_NEW: 'The query {replaced} failed. A search was conducted for {new}.',
    THE_SERVICE_OF_ELECTRONIC_ORDER_IS_TEMPORARILY_UNAVAILABLE: 'The service of electronic order is temporarily unavailable.',
    THE_SPECIFIED_DOCUMENT_HAS_ALREADY_BEEN_DIGITIZED: 'The specified document has already been digitized.',
    THE_SPECIFIED_RESOURCE_WAS_NOT_FOUND_IN_THE_SYSTEM: 'The specified resource was not found in the system.',
    THIS_EMAIL_ADDRESS_IS_ALREADY_IN_USE_IN_THE_SYSTEM: 'This email address is already in use in the system.',
    THIS_USERNAME_IS_ALREADY_IN_USE: 'This username is already in use.',
    TITLE: 'Title',
    TO_MAIN: 'To main',
    TO_ORDER_A_DOCUMENT_YOU_MUST_BE_AUTHORIZED_IN_THE_SYSTEM_AND_HAVE_THE_CORRECT_NUMBER_OF_THE_LIBRARY_CARD: 'To order a document you must be authorized in the system and have the correct number of the library card.',
    TO_USE_THE_SERVICE_OF_ELECTRONIC_ORDER__EORDERGETREADERNUMBERLINK: 'To use the service of electronic order, {eorderGetReaderNumberLink}.',
    UNAVAILABLE: 'unavailable',
    UNDEFINED_KEY_0: '',
    UNDEFINED_KEY_1: '',
    UNDEFINED_KEY_2: '',
    UNDEFINED_KEY_3: '',
    UNDIGITIZED_DOCUMENTS: 'Undigitized documents',
    UPDATING_THE_DATA: 'Updating the data...',
    UPLINK: 'Uplink',
    USERNAME: 'Username',
    VIEW: 'View',
    VIEW_RECORD: 'View record',
    VIEW_THE_RESULTS_OF_AN_EXTERNAL_RESOURCE: 'View the results of an external resource',
    VOLUME: 'Volume',
    VOTE_FOR_DIGITIZING: 'Vote for digitizing',
    YOUR_REQUEST_FOR_DIGITIZING_THIS_DOCUMENT_WAS_NOT_PREVIOUSLY_REGISTERED: 'Your request for digitizing this document was not previously registered.',
    YOU_HAVE_REACHED_THE_LIMIT_OF_APPLICATIONS__N_TIMES_PER_DAY__PLEASE_TRY_AGAIN_LATER: 'You have reached the limit of applications ({n} times per day). Please try again later.',
    YOU_HAVE_TO_GET_A_LIBRARY_CARD_OF_RSL: 'you have to get a library card of RSL',
    YOU_HAVE_TO_LOGIN_TO_ADD_DOCUMENT_TO_FAVORITES: 'You have to login to add document to favorites.',
    YOU_HAVE_TO_LOGIN_TO_DOWNLOAD_THIS_FILE: 'You have to login to download this file.',
    YOU_HAVE_TO_LOGIN_TO_ORDER_THIS_DOCUMENT: 'You have to login to order this document.',
    // Здесь начинаются переводы, которых не было в изначальном файле
    LOGIN_SIMPLE: 'Login',
    OPEN_SEARCH: 'Open search',
    OPEN_MENU: 'Open menu',
    SERVICES_SIMPLE: 'Services',
    REFERENCE_INFORMATION: 'Reference information',
    HIDE_OR_SHOW_LIST: 'Hide / show',
    CHOOSE_ALL: 'Choose all',
    ACCESS_FREE: 'Free access',
    ACCESS_LIMITED: 'Limited access',
    CHOOSE_FROM_THE_DIRECTORY: 'Choose from the directory',
    REMOVE_FILTER: 'Remove filter',
    SYSTEM_NUMBER: 'System №',
    SEE_RELATED_DOCUMENTS: 'See related documents',
    QUOTES_FROM_TEXT: 'Quotes from text',
    ADD_TO_FAVORITES: 'Add to favorites',
    REMOVE_FROM_FAVORITES: 'Remove from favorites',
    VIEWED_DOCUMENTS: 'Viewed documents',
    MARKERS: 'Markers',
    MORE_INFO: 'View',
    CLOSE_MODAL_WINDOW: 'Close modal window',
    CHOOSED_LANGUAGES: 'Choosed languages',
    CHOOSED_SPECIALITIES: 'Choosed specialities',
    PUBLISHED_IN: 'Published in',
    // New

    SKETCHES: 'Sketches',
    SEARCH_BY_TEXT: 'Search by text',
    ONLINE_VIEWER: 'Online viewer',
    OPEN_DOCUMENT: 'Open document',
    NEGATIVE: 'Negative',
    CHANGE_VIEW_MODE: 'Change view mode',
    NEXT_PAGE: 'Next page',
    LAST_PAGE: 'Last page',
    PREVIOUS_PAGE: 'Previous page',
    FIRST_PAGE: 'First page',
    ROTATE_LEFT: 'Rotate left',
    ROTATE_RIGHT: 'Rotate right',
    FULL_WIDTH: 'Full width',
    FULL_HEIGHT: 'Full height',
    LEFT: 'Left',
    RIGHT: 'Right',
    UP: 'Up',
    DOWN: 'Down',
    ZOOM_IN: 'Zoom in',
    ZOOM_OUT: 'Zoom out',
    GO_TO_MAIN_PAGE: 'Go to main page',
    GO_TO_PREVIOUS_PAGE: 'Go to previous page',
    GO_TO_NEXT_PAGE: 'Go to next page',
    HIDE_PANEL_WITH_PREVIEW_PAGES: 'Hide panel with preview pages',
    FIT_PAGE_BY_WIDTH: 'Fit page by width',
    FIT_PAGE_BY_HEIGHT: 'Fit page by height',
    SCROLL_CURRENT_PAGE: 'Scroll current page',
    SHOW_HIDE_NAVIGATION_PANEL: 'Show/Hide navigation panel',
    PAGE_SCALING: 'Page scaling',
    PREVIEW_PAGES_OF_THE_DOCUMENT: 'Preview pages of the document. You can click on this thumbnail, to open current page',
    MENU_DESCRIPTION: 'In the menu section you can go to your personal account, switch the language or select another service of the RSL. Sections are available in the sidebar, they will help simplify the work with the document',
    DOWNLOAD_WITHOUT_SPEED_LIMIT: 'Download without speed limit',
    DOWNLOAD_NORMALLY: 'Download normally',
    FOUND: 'Found',
    DOCUMENT_DOES_NOT_SUPPORT_SEARCH: 'Document does not support search',
    SHOW_OR_HIDE: 'Hide / Show',
    TO_WATCH_DOCUMENT_USE_SEARCH: 'To watch document, use search system',
    YOU_HAVE_NO_BOOKMARKS_TO_ADD_BOOKMARKS_USE_THE_BUTTON_ADD_TO_BOOKMARKS: 'You have no bookmarks! To add bookmarks use the button add to bookmarks.',
    IN_THE_TOP_TOOLBAR: 'in the top toolbar.',
    ADD_TO_CART: 'Add to cart',
    BOOKMARK: 'Add to bookmarks',
    COMMENT: 'ADD page comment',
    ORDERS: 'Orders',
    BACK: 'Back',
    DELETE_ORDER: 'Delete order',
    BASKET: 'Basket',
    CURRENT: 'Current',
    ARCHIVE: 'Archive',
    ORDER_NUMBER: 'Order № ',
    PAGES: ' pages.',
    NOT_CONFIRMED: 'Not confirmed',
    REPEAT_ORDER: 'Repeat order',
    YOU_HAVE_NO_ORDERS: 'You have no orders',
    TO_ADD_ORDER: 'To add order check it out in cart',
    YOU_HAVE_NO_CURRENT_ORDERS_TO_ADD_ORDER_CHECK_IT_OUT_IN: 'You have no current orders. To add order check it out in ',
    IN_CART: 'Cart',
    BY_WIDTH: 'By width',
    BY_HEIGHT: 'By height'
};
